// Citation (contracts 1.0 section 3; ADR-027): every instruction, limit and consequence names its
// page — and a firm rule names the firm's document, which has no page the runtime knows.
import { z } from "zod";
import { NonEmpty, strictObject } from "./primitives.js";
/** `p.20` · `pp.11–13` · `pp.12–13, 43` — a page, a range with an en dash, or a list of either. */
export const PAGES_RE = /^(p\.\d+|pp\.\d+(–\d+)?(,\s*\d+(–\d+)?)+|pp\.\d+–\d+)$/;
export const Pages = z.string().regex(PAGES_RE, "expected p.20, pp.11–13 or pp.12–13, 43");
/** A page of the guide. `kind` absent means `guide` (1.3, additive). */
export const Citation = strictObject({
    kind: z.literal("guide").optional(),
    doc: NonEmpty,
    pages: Pages,
    section: NonEmpty.optional(),
    docVersion: NonEmpty,
});
/**
 * A firm rule's source (ADR-027): the firm's document as the overlay named it, and the overlay's
 * approval time. No pages and no section — the shape refuses them. Only a ContentChunk may carry one.
 */
export const FirmCitation = strictObject({
    kind: z.literal("firm"),
    doc: NonEmpty.max(200),
    docVersion: NonEmpty,
});
/** What a chunk cites: a page of the guide, or a firm rule's document. Discriminated on `kind`. */
export const AnyCitation = z.union([FirmCitation, Citation]);
/** Narrows a chunk's citation: true when it names a page of the guide. */
export const isGuideCitation = (c) => c.kind !== "firm";
//# sourceMappingURL=citation.js.map